/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface AcknowledgeTalentRecommendation {
  type: AcknowledgeTalentRecommendationTypeEnum;
  reasonForReject?: string | null;
}
export enum AcknowledgeTalentRecommendationTypeEnum {
  Approve = 'Approve',
  Reject = 'Reject'
}
